
const upcoming_badge_text = "Coming Soon";
window.FrenzyProductGridChangeCallBack = function(html,data){
  const productTags = data?.org_product_tags;
  let BadgeHTML = '';
  if(productTags){
    let show_upcoming_badge = false;
    (productTags || []).map((x,i) => {
      if(x.includes("NYP")){
        show_upcoming_badge = true;
      }
    })
    if(show_upcoming_badge){
      BadgeHTML += '<span class="frenzy_tag badge upcoming_tag">'+upcoming_badge_text+'</span>';
    }
    html.querySelector('.frenzy_product_tags').insertAdjacentHTML('beforeend',BadgeHTML);
  }
}